/* eslint-disable no-unmodified-loop-condition */
// https://dev.azure.com/SyrenisLimited/CassieCloud/_wiki/wikis/CassieCloud.wiki/141/UX-Usability-Guidelines?anchor=date-formats
export const DATE_FORMAT = 'yyyy/MM/dd'
export const DATE_FORMAT_MONTH_YEAR = 'MMMM yyyy'
export const DATE_TIME_FORMAT = 'yyyy/MM/dd HH:mm:ss'
export const DATE_TIME_FORMAT_NO_SECONDS = 'yyyy/MM/dd HH:mm'
export const DATE_FORMAT_DATE_PICKER = 'yyyy-MM-dd'
export const DATE_FORMAT_CHARTS = 'yyyy-MM-dd'
export const DATE_FORMAT_DAY = 'dd MMM yyyy'
export const DATE_FORMAT_WEEK = 'dd MMM yyyy'
export const DATE_FORMAT_MONTH_YEAR_SHORT = 'MMM yyyy'

// This function formats a Date object into "YYYY/MM/DD HH:MM:SS" in UTC
// Would have been nice to use library date-fns-tz but we were concerned about updating
// date-fns to v3+ in case it has breaking changes, we have a lot of date-fns usage.
export const formatUtcDate = date => {
	const pad = n => n.toString().padStart(2, '0')
	return (
		date.getUTCFullYear() +
		'/' +
		pad(date.getUTCMonth() + 1) +
		'/' +
		pad(date.getUTCDate()) +
		' ' +
		pad(date.getUTCHours()) +
		':' +
		pad(date.getUTCMinutes()) +
		':' +
		pad(date.getUTCSeconds())
	)
}
